// Section « Points d'appui » (sections/pressure-points.liquid).
// Les trois positions sont toutes présentes dans le DOM ; le script ne fait que
// déplacer la classe qui rend l'une visible. Sans JavaScript, la position posée
// par le Liquid (la première) reste affichée et la section garde son sens.
class PressurePoints extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-pressure-option]'));
    if (this.buttons.length === 0) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button.dataset.pressureOption));
    });

    const actif = this.buttons.find((b) => b.getAttribute('aria-pressed') === 'true');
    this.select((actif || this.buttons[0]).dataset.pressureOption);
  }

  select(posture) {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.pressureOption === posture));
    });
    this.querySelectorAll('[data-posture]').forEach((groupe) => {
      groupe.classList.toggle('sv-anat__pose--on', groupe.dataset.posture === posture);
    });
    this.querySelectorAll('[data-pressure-caption]').forEach((legende) => {
      legende.hidden = legende.dataset.pressureCaption !== posture;
    });
  }
}

if (!customElements.get('pressure-points')) {
  customElements.define('pressure-points', PressurePoints);
}
